const APPS = {
  AWTECH: {
    label: "awtech",
    number: 70,
    publicUrl: "www.awtech.be",
  },
  INTRANET: {
    label: "intranet",
    number: 10,
    publicUrl: "portal.welda.be",
  },
  WELDA: {
    label: "welda",
    number: 10,
    publicUrl: "portal.welda.be/site/10",
  },
  WELDA_MACHINERY: {
    label: "welda-machinery",
    number: 15,
    publicUrl: "portal.welda.be/site/15",
  },
};

const APP_DESTINATIONS = {
  ROOT: {
    KEY: "ROOT",
    PREFIX: "",
  },
  SITE: {
    KEY: "SITE",
    PREFIX: "/site",
  },
  INTRANET: {
    KEY: "INTRANET",
    PREFIX: "",
  },
  STATIC: {
    KEY: "STATIC",
    PREFIX: "/static",
  },
};

const APP_BY_DOSSIER = {
  [APPS.AWTECH.number]: APPS.AWTECH,
  [APPS.INTRANET.number]: APPS.INTRANET,
  [APPS.WELDA.number]: APPS.WELDA,
  [APPS.WELDA_MACHINERY.number]: APPS.WELDA_MACHINERY,
};

module.exports = { APPS, APP_BY_DOSSIER, APP_DESTINATIONS };
